import React from "react";

const BatchInfo = ({ batch }) => {
  return (
    <div className="md:w-1/4 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-md p-4">
      <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
        Batch Information
      </h2>
      <div className="space-y-2">
        <p className="text-sm text-gray-600 dark:text-gray-400">
          <strong className="text-gray-900 dark:text-white">Batch Name:</strong>{" "}
          {batch?.batch_name}
        </p>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          <strong className="text-gray-900 dark:text-white">
            Batch Number:
          </strong>{" "}
          {batch?.batch_number}
        </p>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          <strong className="text-gray-900 dark:text-white">Created At:</strong>{" "}
          {new Date(batch?.created_at).toLocaleString()}
        </p>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          <strong className="text-gray-900 dark:text-white">
            First ICCID:
          </strong>{" "}
          {batch?.first_iccid}
        </p>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          <strong className="text-gray-900 dark:text-white">Last ICCID:</strong>{" "}
          {batch?.last_iccid}
        </p>

        <p className="text-sm text-gray-600 dark:text-gray-400">
          <strong className="text-gray-900 dark:text-white">Provider:</strong>{" "}
          {batch?.provider}
        </p>
        
      </div>
    </div>
  );
};

export default BatchInfo;
